// extracted by mini-css-extract-plugin
export default {"addressItem":"addressItem-SbSFT4","icon":"icon-o2CgsM","row":"row-O80mwS","text":"text-FtrF3N","item":"item-XHPjAR","helpIcon":"helpIcon-TPfIr7","wordWrap":"wordWrap-U2rItN"};